// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AcademiaIcon-cls1___e8e46aa591300897964{/*!*/}.AcademiaIcon-cls2___94bf5b9f6cd233ea0c9{}.AcademiaIcon-cls2___94bf5b9f6cd233ea0c9.AcademiaIcon-darkMode___0a09238f71390ccec74{filter:brightness(0) saturate(100%) invert(99%) sepia(0%) saturate(0%) hue-rotate(321deg) brightness(102%) contrast(102%)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "AcademiaIcon-cls1___e8e46aa591300897964",
	"cls2": "AcademiaIcon-cls2___94bf5b9f6cd233ea0c9 AcademiaIcon-cls1___e8e46aa591300897964",
	"darkMode": "AcademiaIcon-darkMode___0a09238f71390ccec74"
};
export default ___CSS_LOADER_EXPORT___;
